import { GiveawayRewardResponseDto } from '@/store/services/MidleNestApi.service';
import { useTranslation } from 'react-i18next';
import React from 'react';
import { useModal } from '@/hooks';
import { Link } from 'react-router-dom';
import { CopyClick } from '@/components/shared/copy-click';

type Props = GiveawayRewardResponseDto;

export default function RewardView(props: Props) {
  const { t } = useTranslation();
  const { showModal } = useModal();

  return (
    <tr className='sm:text-base text-sm'>
      <td className='py-5'>
        <div className='flex items-center gap-2 text-left'>
          <div className='flex-1 w-fit truncate'>{props.title.en}</div>
        </div>
      </td>
      {/* <td className='hidden lg:table-cell'>{props.rewardToken}</td>
          <td className='hidden lg:table-cell'>{props.reward.toFixed(2)}</td> */}
      <td className='hidden lg:table-cell'>
        {props.reward.toFixed(2)} {props.rewardToken}
      </td>
      <td className='hidden lg:table-cell'>
        <td className='py-2'>
          {props.wallet ? <CopyClick>{props.wallet || ''}</CopyClick> : ' - '}
        </td>
      </td>
      {props.rewardDistributed ? (
        <td className='hidden lg:table-cell'>{t('distributed')}</td>
      ) : (
        <td className='hidden lg:table-cell'>{t('not-distributed')}</td>
      )}
      <td className='space-x-2'>
        <Link to={'/settings/rewards/' + props.rewardId}>
          <i className='icon-add'></i>
        </Link>
      </td>
    </tr>
  );
}
